import PaymentRecordDetails from "../../../../components/recordDetails/paymentRecordDetails";
import { refreshDataTable } from "../../../../components/recordDetails/recordDetailUtils";

  const paymentCollectionDetailPage = (props: any) => {

    return  (<PaymentRecordDetails
      viewPageBluPrint={props.viewPageBluPrint}
    isCreateFlow={props.isCreateFlow}
    isRelatedInfo={props.isRelatedInfo}
    editForm={props.viewPageBluPrint ? props.viewPageBluPrint.editForm : []}
    dependantFields={
      props.viewPageBluPrint?.dependency ? props.viewPageBluPrint.dependency : []
    }
    dataApi={props.viewPageBluPrint ? props.viewPageBluPrint.dataApi : ""}
    viewApi={props.viewPageBluPrint ? props.viewPageBluPrint.viewApi : ""}
    createApi={props.viewPageBluPrint ? props.viewPageBluPrint.createApi : ""}
    recordId={props.urlparams.get("recordId") ?? ""}
    urlparams={props.urlparams}
    setOpen={props.setOpen}
    userAccessLevel={props.userAccessLevel}
    platformAction={props.platformAction}
    parentEntity={props.viewPageBluPrint ? props.viewPageBluPrint.parentEntity : ""}
    recordIds={props.recordIds}
    refreshTable={() => refreshDataTable(props.viewPageBluPrint?.refreshOnSave, props.refreshTable)}
    allowEdits={props.allowEdits ?? true}
    selectedRows={props.selectedRows}
    moduleCode={props.moduleCode}
  />)
  }


export default paymentCollectionDetailPage;
